import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["image","fileInput","imageArea","fileInputArea","errorMessage","deleteFlag"]

    connect(){
        //画像が登録済みの場合は表示
        const src = this.imageTarget.getAttribute('src')
        if(src == ''){
            this.fileInputAreaTarget.classList.remove('is-hidden')
        }else{
            this.imageAreaTarget.classList.remove('is-hidden')
        }
    }

    display(){
        const imageTarget = this.imageTarget
        const fileInput = this.fileInputTarget
        const reader = new FileReader();
        reader.readAsDataURL(fileInput.files[0])
        this.errorMessageTarget.innerText = ''
        this.deleteFlagTarget.value = false
        reader.addEventListener("load",(event) =>{
            imageTarget.setAttribute('src',event.target.result)
            this.imageAreaTarget.classList.remove('is-hidden')
            this.fileInputAreaTarget.classList.add('is-hidden')
        })
    }
    remove(){
        this.imageTarget.setAttribute('src','')
        this.fileInputTarget.value = ''
        this.imageAreaTarget.classList.add('is-hidden')
        this.fileInputAreaTarget.classList.remove('is-hidden')
        this.errorMessageTarget.innerText = ''
        this.deleteFlagTarget.value = true
    }
}